module.exports = __webpack_public_path__ + "img/29-Elasticity.6412e8c0.png";